import React, { Component } from 'react';
import $ from "jquery";

class LeadLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false
    }

    this.isLogin = this.isLogin.bind(this);
    this.getCookie = this.getCookie.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }
  componentDidMount() {
    $.ajaxSetup({
      cache:true
    });
    setTimeout(() => {
      $.getScript("https://g.alicdn.com/??webbased/feloader/0.0.2/feloader-min.js,mtb/lib-windvane/3.0.7/windvane.js,webbased/h5baseres/0.0.22/polyfill.js,code/npm/@ali/rox-driver/0.0.18/index.js,magic-cube/wap-loader/0.1.9/index.js");
    }, 1000);
    
    // if(window.pageConfig && window.pageConfig.loginBanner && !this.isLogin()) {
    //   this.setState({
    //     showModal: true
    //   })
    // }

    if(!this.isLogin()) {
      this.setState({
        showModal: true
      })
    }
  }

  isLogin() {
    return this.getCookie("__cn_logon_id__");
  }

  getCookie(sKey) {
		return (
			decodeURIComponent(
				document.cookie.replace(
					new RegExp(
					`(?:(?:^|.*;)\\s*${encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&')}\\s*\\=\\s*([^;]*).*$)|^.*$`
					),
					'$1'
				)
			) || null
		);
	}

  handleClose() {
    this.setState({
      showModal: false
    });
  }

  handleLogin() {
    window.location.href = `https://login.1688.com/member/signin.htm?Done=${encodeURIComponent(window.location.href)}`;
  }

  render() {
    return (
      <div>
        {
          this.state.showModal &&
          <div className="leadLoginModal" id="leadLoginModal">
            <div className="left">
              <img className="img" src="https://img.alicdn.com/imgextra/i4/O1CN01BrMfFQ1jUrZGtiAc3_!!6000000004552-2-tps-98-90.png" alt="" />
              <text className="txt">
                一键登录
                <text className="highlight">【领5元补贴】</text>
                为你精心挑选低价货源
              </text>
            </div>
            <div className="right" id="leadLoginModalLoginbtn">
              <div className="btn" onClick={this.handleLogin}>一键登录</div>
            </div>
            <div className="close" onClick={this.handleClose} />
          </div>
        }
      </div>
      
    );
  }
}

export default LeadLogin;